<template>
  <div class="modal" v-if="seen">
    <div class="deletefile" v-if="!loader && !success">
      <span @click="closebox" class="closefile">
        <img src="@/assets/Close Button.svg" />
      </span>
      <!-- <div class="d-flex justify-content-center align-items-center mt-4">
                <img src="@/assets/trash-can.svg" />
            </div> -->
      <div class="header d-flex justify-content-center align-items-center mt-2">
        <h6><strong>Block user?</strong></h6>
      </div>
      <div class="cgn text-center my-2">
        <span>Are you sure you want to block <strong>{{ names }}</strong></span>
      </div>
      <div class="save">
        <span class="btn-move-to-trash" @click="blockuser">
          <svg style="width:22px;height:22px" viewBox="0 0 24 24">
            <path fill="#fff"
              d="M19,21V19H15V17H19V15L22,18L19,21M13,18C13,18.71 13.15,19.39 13.42,20H2V17C2,14.79 5.58,13 10,13C11,13 11.96,13.09 12.85,13.26C13.68,13.42 14.44,13.64 15.11,13.92C13.83,14.83 13,16.32 13,18M4,17V18H11C11,16.96 11.23,15.97 11.64,15.08L10,15C6.69,15 4,15.9 4,17M10,4A4,4 0 0,1 14,8A4,4 0 0,1 10,12A4,4 0 0,1 6,8A4,4 0 0,1 10,4M10,6A2,2 0 0,0 8,8A2,2 0 0,0 10,10A2,2 0 0,0 12,8A2,2 0 0,0 10,6Z" />
          </svg>
          Continue
        </span>

        <span class="btn-delete-permanently" @click="closebox">
          Cancel
        </span>
      </div>
    </div>
    <div class="deletefile loader" v-if="loader">
      <span>Blocking <strong>{{ names }}</strong></span>
      <br />
      <span><img src="@/assets/30.gif" /></span>
    </div>
    <div class="deletefile loader" v-if="!loader && success">
      <span><strong>{{ names }}</strong> blocked successfully</span>
      <span class="btn-close" @click="closebox">
        Ok
      </span>
    </div>
  </div>
</template>
<style scoped>
.header {
  padding: .5em 0 0 0 !important;
}

.header h3 {
  font-size: 22px;
  font-weight: bold;
}

.save {
  margin-top: 0 !important;
}

.cgn {
  display: flex;
  flex-direction: column;
}

.cgn span {
  margin-bottom: .4em;
  font-size: 14px;
}

.deletefile {
  padding: 2em !important;
}

.modal div.deletefile {
  width: 420px !important;
}

.modal div.deletefile div {
  width: 100% !important;
  margin-left: 0 !important;
}

.save {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}

.save span {
  flex: 1 !important;
}

.save .btn-move-to-trash {
  background: #3F96D1 !important;
  color: #fff !important;
  font-size: 13px !important;
}

.btn-close {
  display: inline-block !important;
  background: #3F96D1 !important;
  color: #fff !important;
  font-size: 13px !important;
  width: 100% !important;
  border-radius: 8px;
  padding: 16px 0 !important;
  font-size: 15px !important;
  cursor: pointer;
  margin-top: 6px;
}

.save .btn-delete-permanently {
  background: transparent !important;
  border: 1px solid #FC6D6C !important;
  font-size: 13px !important;
  color: #FC6D6C !important;
}

.save .btn-delete {
  background: transparent !important;
  border: 1px solid #FC6D6C !important;
  font-size: 13px !important;
  color: #FC6D6C !important;
}

.modal div.deletefile .closefile {
  top: 13px !important;
  right: 13px !important;
}
</style>

<script>
import cookies from '@/services/cookies'
export default {
  data() {
    return {
      names: '',
      seen: false,
      loader: false,
      error: false,
      success: false,
      index: null,
      id: null
    }
  },
  methods: {
    logincall() {
      this.$parent.logincall()
    },
    str_text(str) {
      return str.length > 60 ? str.substr(0, 60) + '...' : str
    },
    load(index, id, names) {
      this.seen = true
      this.index = index
      this.id = id
      this.names = names
    },
    blockuser() {
      this.loader = true

      let that = this

      let data = {
        id: this.id,
        token: cookies.getCookie('token')
      }

      this.$socket.emit('block-user', data, function (data) {
        if (data.data === true) {
          that.loader = false
          that.success = true

          that.$parent.updateBlock(that.index, false)
        }

        if (data.data === false) {
          that.seen = false
          that.logincall()
          that.$router.push('/login')
        }
      })
    },
    closebox() {
      this.seen = false
      this.loader = false
      this.success = false
    }
  }
}
</script>
